import React, { useState } from 'react';
import styled from 'styled-components';
import TagItem from './TagItem';
import TagInput from './TagInput';

interface TagsContainerProps {
  tags: string[];
  onTagAdd: (tag: string) => void;
  onTagRemove: (tag: string) => void;
}

// タグコンテナ
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
  margin-bottom: 8px;
`;

const TagsContainer: React.FC<TagsContainerProps> = ({ 
  tags, 
  onTagAdd, 
  onTagRemove 
}) => {
  const [showTagInput, setShowTagInput] = useState(false);
  const [tagInput, setTagInput] = useState('');

  const handleTagSubmit = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && tagInput.trim()) {
      onTagAdd(tagInput.trim());
      setTagInput('');
      setShowTagInput(false);
    }
  };

  return (
    <Container>
      {tags.map((tag, index) => (
        <TagItem 
          key={index} 
          tag={tag} 
          onRemove={() => onTagRemove(tag)} 
        />
      ))}
      {showTagInput ? (
        <TagInput
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={handleTagSubmit}
          onBlur={() => setShowTagInput(false)}
          autoFocus
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        />
      ) : (
        <TagItem 
          isAddButton
          tag="+ タグ追加"
          onClick={(e) => {
            e.stopPropagation();
            setShowTagInput(true);
          }}
        />
      )}
    </Container>
  );
};

export default TagsContainer; 